import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material';
import { ContactsService } from '../../../_services/admin/contacts.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {

  contactList: any[] = [];
  tempContactList: any[] = [];

  constructor(private contactsService: ContactsService,
    private snackBar: MatSnackBar,
    private myTitle: Title) {
  }

  ngOnInit() {
    this.myTitle.setTitle('Contacts | ' + environment.commonTitle);
    this.getContacts();
  }

  getContacts() {
    this.contactsService.getAllContacts().subscribe(result => {
      if (result.data) {
        this.contactList = result.data;
        this.tempContactList = [...this.contactList];
      }
    });
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.tempContactList.filter(function (d) {
      return d.name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    this.contactList = temp;
  }

  deleteContact(id: number) {
    Swal({
      title: 'Are you sure you want to remove contact?',
      text: '',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true,
      focusConfirm: false
    }).then((res) => {
      if (res.value) {
        this.contactsService.deleteContact(id).subscribe(result => {
          if (result.data) {
            this.openSnackBar('Category deleted succcessfully.', 'Success');
            this.getContacts();
            // ------ delete row -------
            // const deleteIndex: any = this.contactList.findIndex(x => x.id === id);
            // if (deleteIndex !== -1) {
            //   this.contactList.splice(deleteIndex, 1);
            // }
            // -------------------------
          }
        });
      } else if (res.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }

}
